import React from 'react';
import {
   CLUES,
   CLUES_RELEASED,
   GAME_STATUS, GAME_STATUS_COMPLETED, START_TIME,
   STARTED_AT,
   TITLE
} from "../../constants/Game";
import moment from "moment/moment";
import {COMMON_DATE, SHORT_DATE} from "../../constants/Strings";

import '../../global.css';
import './HomePage.css';
import {sortStatsByDate} from "../common_page_elements";
import {sortStatsByFastestTime} from "../common_page_elements";

/**
 * Components for Listing Game played entries.
 */

export const PlayedGameListing = props => {
   const {title, gameEntries, showUser} = props;

   return (
      <div>

         <h3 className="HomePage-left-margin-above-bootstrap-list small-top-margin clear-all">
            {title}
         </h3>
         <ul className="list-group home-list-margins">
            {gameEntries ? renderGameEntryList(gameEntries, showUser) : "Loading..."}
         </ul>
      </div>
   )
};

/**
 * A single item in a Game Entry List.  On Home page
 * */
const GameEntryListItem = ({entry, id, showUser}) => {

   const title = entry[TITLE] ? entry[TITLE] : "(Hunt deleted by author)";

   const gamePlayedText = dateTextOrMissing(entry[STARTED_AT], entry[START_TIME], COMMON_DATE);
   const gamePlayedTextShort = dateTextOrMissing(entry[STARTED_AT], entry[START_TIME], SHORT_DATE);
   const statusText = formatStatus(entry);
   const statusTextShort = formatStatusShort(entry);
   const userString = showUser ? entry.username : "";

   return (
      <li key={id} className="list-group-item list-item-small">
         <div>
            <div className="list-group-item-text pull-right">
               <span className="text-danger left-margin right-margin full-text">{statusText}</span>
                  <span className="text-danger left-margin right-margin short-text">{statusTextShort}</span>
               <span className="lighter-highlight normal-text"> {gamePlayedText} </span><span className="lighter-highlight veryshort-text"> {gamePlayedTextShort} </span>
            </div>
            <h5 className="list-group-item-heading "> {title}
                  <span className="secondary-highlight"> {userString}  </span></h5>
         </div>
      </li>
   );
};

// Used by Hunt Activity screen and Admin screen (twice)
export const GameStats = props => {
   const {game, stats, title, onGameDetailsSelect, showUser} = props;

   const displayTitle = !!title ? title
         : !!game ? game[TITLE] : "Stats";

   const sortedStats = showUser ? sortStatsByDate(stats) : sortStatsByFastestTime(stats)

   return (
      <div>
         {onGameDetailsSelect &&
         <button className="btn-link pull-right" onClick={onGameDetailsSelect}> See Hunt Details </button>
         }
         <h3 className="HomePage-left-margin-above-bootstrap-list small-top-margin black">
            {/*<span className="plain">Activity for </span>*/}
            {displayTitle}
         </h3>
         <div className="big-left-margin">By most recent</div>
         <ul className="list-group border-1 home-list-margins">
            {stats ? renderGameStatsList(sortedStats, showUser) : "Loading..."}
         </ul>
      </div>
   )
};

// Used only by GameStats (this file)
function renderGameStatsList(gameStats, showUserId) {
   if (!gameStats) {
      return <div>Loading...</div>;
   }
   if (gameStats.length === 0) {
      return <li key={0} className="list-group-item list-item-small">
         <h5 className="list-group-item-heading "> None </h5>
      </li>
   }
   let index = 0;

   // foreach entry in gameStats
   //   return _.values(gameEntries).map((entry) => {
   return gameStats.map((entry) => {

      // sometimes id can be missing
      const userPart = entry.userId ? entry.userId : entry.toString();
      const gamePart = entry.lastUpdated ? entry.lastUpdated.toString() : "";
      const id = userPart + gamePart;

      const isComplete = entry.finishTime

      const visIdLong = entry.userId;
      const visIdShort = (entry.userId.length > 4) ? entry.userId.substring(0, 4) : entry.userId;
      var userStringBold = entry.name
         ? entry.name
         : "";
      if (userStringBold.length > 15) userStringBold = userStringBold.substring(0,16) + "..";

      const userStringPlain = entry.name
         ? showUserId
            ? " ("+visIdLong+")"
            : ""
         : showUserId
            ? "Anonymous ("+visIdLong+")"
            : "Anonymous-"+visIdShort;

      const statusString = formatStatus(entry);
      const statusStringShort = formatStatusShort(entry);

      const onClueOrDurationString = isComplete ? "" :  "On clue " + (entry.farthestClue ? entry.farthestClue : "1");
      const dateLast = isComplete ? (entry.finishTime ? entry.finishTime : entry.finishedAt)
                              : !!entry.lastUpdated  ? entry.lastUpdated : entry.startTime;
      const dateStart = entry.startTime ? entry.startTime : entry.startedAt;

      const dateString = dateTextForGameEntryLine(dateStart, dateLast, isComplete);

      const elapsedTime = isComplete ? elapsedTimeStr(dateStart, dateLast) : null;

      const score = isComplete ? "Score: " + entry.score : ""
      const hasSkippedClues = entry.skippedClues && entry.skippedClues.length > 0
      const hasExpiredClues = entry.timedOutClues && entry.timedOutClues.length > 0
      const skippedClues = hasSkippedClues ? "Skipped clues: " + entry.skippedClues : ""
      const expiredClues = hasExpiredClues ? "Expired clues: " + entry.timedOutClues : ""
      const hasSecondLine = score || hasSkippedClues || hasExpiredClues

      const hasReview = entry.reviewDate;
      const hasReport = entry.reportDate;
      const reportText = hasReport ? entry.reportText : "";
      // const reportDate = hasReport ? dateTextOrMissing(entry.reportDate, null, COMMON_DATE) : "";

      // iOS generates 2.71..something if the user submits a rating without stars.
      const hasStars = entry.reviewRating && Math.abs(entry.reviewRating - 2.71) > 0.1

      const stars = hasStars ? "Rated " + entry.reviewRating + " stars" : "";
      const reviewText = hasReview ? entry.reviewText : "";
      // const reviewDate = hasReview ? dateTextOrMissing(entry.reviewDate, null, COMMON_DATE) : "";

      const hasGameTitle = !!entry.gameTitle;

      index++;
      const indexString = index + ". ";

      // return a GameListItem
      return (
         <li key={id} className="list-group-item list-item-small">
            <div className="larger">
               <span>{indexString}</span>
               <span className=""> <b>{userStringBold}</b> {userStringPlain} </span>
               {hasGameTitle &&
                  <span className="big-left-margin secondary-highlight right-align"> <b>{entry.gameTitle}</b> <br/> </span>
               }
               <span className="left-margin full-text">{statusString} </span>  <span className="big-left-margin short-text">{statusStringShort}</span>
               <span className=""> {onClueOrDurationString}  </span>
               {!!elapsedTime && <span className="revert-link"> - Time: <b>{elapsedTime}</b>  </span>}
               <span className="left-margin secondary-highlight"> {dateString}  </span>
            </div>
            {hasSecondLine &&
            <div className="big-left-margin">
               <span className="black"> <b>{score}</b> </span>
               <span className="highlight left-margin"> {skippedClues} </span>
               <span className="highlight left-margin">  {expiredClues} </span>
            </div> }
            {hasReview &&
            <div className="big-left-margin">
               <span className="lighter-highlight"> <b>{stars}</b> </span>
               <span className="lighter-highlight left-margin"> {reviewText} </span>
               {/*<span className="">  ({reviewDate}) </span>*/}
            </div>}
            {hasReport &&
            <div className="big-left-margin">
               <span className="red"> REPORT: </span>
               <span className="red left-margin"> {reportText} </span>
               {/*<span className="">  ({reportDate}) </span>*/}
            </div>}
         </li>
      );
   });
}

// helper method to render all the list items, on home page.
function renderGameEntryList(gameEntries, showUser) {
   if (!gameEntries) {
      return <div>Loading...</div>;
   }
   if (gameEntries.length === 0) {
      return <li key={0} className="list-group-item list-item-small">
            <h5 className="list-group-item-heading "> None </h5>
            </li>
   }

   // foreach game in gameMap...
   //   return _.values(gameEntries).map((entry) => {
   return gameEntries.map((entry) => {

      // sometimes id can be missing
      const id = entry.id ? entry.id : entry.userId + entry.gameId;

      // return a GameListItem
      return (
         <GameEntryListItem
            key={id}
            entry={entry}
            showUser={showUser}
         />
      );
   });
}

function formatClueProgress(gameEntry, isShort = false) {
   if (!gameEntry[GAME_STATUS] || !(gameEntry[GAME_STATUS] === "RUNNING")) return "";
   if (!gameEntry[CLUES]) return "";

   const clueProgress = gameEntry[CLUES_RELEASED];
   const totalClues = gameEntry[CLUES].length;
   if (isShort) {
      return "Clue " + clueProgress;
   } else {
      return "Clue " + clueProgress + " of " + totalClues;
   }
}

function formatStatus(entry) {
   if (entry.score) return "Completed"
   const gameStateStatus = entry[GAME_STATUS];
   if (gameStateStatus === "PAUSED") return "Paused";
   if (gameStateStatus === "COMPLETED") return "Completed";
   if (gameStateStatus === "RUNNING") return formatClueProgress(entry);
}

function formatStatusShort(entry) {
   const gameStateStatus = entry[GAME_STATUS];
   if (gameStateStatus === "PAUSED") return "Paused";
   if (gameStateStatus === "COMPLETED") return "";
   if (gameStateStatus === "RUNNING") return formatClueProgress(entry, true);
}

/*
Completed today:    today, elapsed, or today at ss time.
HERE

New requirements.  Main line.  Date string.
   1) If game in progress AND game started today, change date string to Started today at TimeStamp hh:MM z
   2) If game is completed, AND game completed today. change date to Today.
   2b) If game complete, add Elapsed time: h:mm and ss secon
 */
function elapsedTimeStr(startedAtFbDate, lastFbDate) {
   if (!startedAtFbDate || !lastFbDate) return null;
   else return formatDuration(startedAtFbDate.toDate(), lastFbDate.toDate());
}

function dateTextForGameEntryLine(startedAtFbDate, lastFbDate, isComplete) {
   if (isComplete) {
      if (!!startedAtFbDate && !!lastFbDate) {
         return isToday(lastFbDate) ? "today" : dateTextOrMissing(lastFbDate, null, COMMON_DATE)
      }
      else if (!!lastFbDate) {
         if (isToday(lastFbDate)) {
            return "today at " + timeFormatSecond(lastFbDate);
         } else {
            return dateTextOrMissing(lastFbDate, null, COMMON_DATE) + " " + timeFormatSecond(lastFbDate)
         }

      } else {
         return "missing date";
      }

   } else {
      // in progress
      if (!!startedAtFbDate && isToday(startedAtFbDate)) {
         return "Started today at " + timeFormatMinute(startedAtFbDate);
      }
      return dateTextOrMissing(lastFbDate, startedAtFbDate, COMMON_DATE)
   }
}

function isToday(firebaseDate) {
   const now = moment();
   const year = now.year();
   const day = now.dayOfYear();

   const givenMoment = moment(firebaseDate.toDate());

   return (givenMoment.dayOfYear() === day & givenMoment.year() === year)
}

function timeFormatMinute(firebaseDate) {
   return moment(firebaseDate.toDate()).format("h:mm a")
}

function timeFormatSecond(firebaseDate) {
   return moment(firebaseDate.toDate()).format("h:mm:ss a")
}

export function dateTextOrMissing(firebaseDate, orFirebaseSecondsSince, formateStr) {
   if (!!firebaseDate) {
      return moment(firebaseDate.toDate()).format(formateStr);
   }
   else if (!!orFirebaseSecondsSince) {
      const date = new Date()
      date.setTime(orFirebaseSecondsSince*1000)
      return moment(date).format(formateStr);
   }
   else {
      return  "missing date";
   }
}

export function dateTextOrNone(firebaseDate, formateStr) {
   if (!firebaseDate) return "";
   return moment(firebaseDate.toDate()).format(formateStr);
}

export function formatDuration(startDate, endDate) {
   if (!startDate || !endDate) return "";

   const millis = endDate.getTime() - startDate.getTime();
   const millisInDay = 24*60*60*1000;
   const days = Math.floor(millis / millisInDay);
   const rem = millis % millisInDay;

   const formattedTime = moment.utc(rem).format('HH:mm:ss');

   if (days > 1) {
      return days + " days, " + formattedTime;
   }
   else if (days === 1) {
      return "1 day, " + formattedTime;
   } else {
      return formattedTime;
   }
}

export default GameEntryListItem;



// WEBPACK FOOTER //
// ./src/components/yourpage/GameEntryListItem.js